module.exports = __webpack_public_path__ + "media/svg-new/biologia-90659bef.svg";